import { useSelector } from 'react-redux'
import { type Nil, Text, type TextProps, Utils } from '@pbt/pbt-ui-components'

import { getUser } from '~/store/reducers/users'

export interface PersonLabelProps extends TextProps {
  personId: string | Nil
}

const PersonLabel = ({ personId, ...rest }: PersonLabelProps) => {
  const person = useSelector(getUser(personId))

  if (!person) {
    return null
  }

  const personLabel = Utils.getPersonString(person)

  return <Text {...rest}>{personLabel}</Text>
}

export default PersonLabel
